// extracted by mini-css-extract-plugin
export default {"wrapTable":"table_wrapTable__fXQtk","table":"table_table__bbKP3","item":"table_item__jxYJv"};